<template>
  <div>
    <div>
      <va-input
        v-model="form.reasonName"
        placeholder="Название повода"
        class="mb-3"
      />
      <div
        v-if="!$v.form.reasonName.required && $v.form.reasonName.$error"
        class="error-message"
      >
        Обязательно для заполнения
      </div>
    </div>
    <div class="mb-3">
      <label for="icon-upload" class="custom-file-upload">
        Загрузить иконку
      </label>
      <input
        id="icon-upload"
        ref="fileInput"
        :disabled="selectedFile.length > 1"
        type="file"
        class="file-input"
        accept="image/x-png,image/jpg,image/jpeg,image/svg+xml"
        @input="onFilePicked($event)"
      />
      <div v-if="removeIcon" class="text-success mt-2" style="font-size: 14px;">
        Иконка будет удалена при сохранении
      </div>
    </div>
    <div class="mb-3" v-if="imageData.length > 0 || (value && value.icon)">
      <div
        v-for="(img, index) in imageData"
        :key="img.id"
        class="uploaded-file"
      >
        <img class="uploaded-file__img" :src="img.img_url" alt="icon" />
        <span
          ><va-button small @click.prevent="removeImg(index)">
            Удалить</va-button
          ></span
        >
      </div>
      <div v-if="value && value.icon && imageData.length === 0 && !removeIcon" class="uploaded-file">
        <img class="uploaded-file__img" :src="value.icon.url" alt="icon" />
        <span
          ><va-button small @click.prevent="removeExistingIcon">
            Удалить</va-button
          ></span
        >
      </div>
    </div>
    <div class="mt-4 text-center">
      <va-button type="button" color="primary" @click="$emit('action', false)">
        Отменить
      </va-button>
      <va-button color="success" type="submit" @click="updateReason">
        Сохранить
      </va-button>
    </div>
  </div>
</template>

<script>
import api from "@/api/axios";
import { required } from "vuelidate/lib/validators";
export default {
  name: "update-reason",
  props: ["value"],
  data() {
    return {
      form: {
        reasonName: this.value.name,
      },
      selectedFile: [],
      imageData: [],
      removeIcon: false,
    };
  },
  validations: {
    form: {
      reasonName: {
        required,
      },
    },
  },
  methods: {
    async updateReason(event) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      } else {
        let iconId = this.value.icon_id;

        // Upload new icon if selected
        if (this.selectedFile.length > 0) {
          const formData = new FormData();
          formData.append("file[0]", this.selectedFile[0], this.selectedFile[0].name);
          const res = await api.post("/upload-file", formData);
          iconId = res.data[0].id;
        } else if (this.removeIcon) {
          iconId = null;
        }

        const data = {
          id: this.value.id,
          name: this.form.reasonName,
          slug: this.value.slug,
          icon_id: iconId,
        };
        this.$emit("input", data);
        this.$emit("action", true);
      }
    },
    onFilePicked(event) {
      if (this.imageData.length >= 1) {
        alert("Максимум 1");
        return;
      }
      this.selectedFile.push(event.target.files[0]);
      const file = event.target.files;
      if (file && file[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData.push({ img_url: e.target.result });
        };
        reader.readAsDataURL(file[0]);
      }
    },
    removeImg(imgId) {
      this.imageData.splice(imgId, 1);
      this.$refs.fileInput.value = "";
      this.selectedFile.splice(imgId, 1);
    },
    removeExistingIcon() {
      this.removeIcon = true;
      this.imageData = [];
    },
  },
};
</script>

<style>
</style>
